import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { OverlayPanel } from "primereact/overlaypanel";
import React, { useEffect, useRef, useState } from "react";
import { LANGUAGES } from "../constants/language";
import { LANGUAGES as LANGUAGES_CONSTANTS, LANGUAGE_CODES } from "../constants/language-constants"; 
import { i18n, initializeI18n } from "../localization/i18n";
import { changeLanguageByUser, translate } from "../localization/translateService";
import { APP_NAME } from "../constants/app-constants";
import registerLogo from "../stories/assets/dotore-logo.svg";

export default function RegisterHeader() {
  const languageDropdownRef = useRef(null);
  const [languageDropdownVisible, setLanguageDropdownVisible] = useState(false);

  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [translations, setTranslations] = useState({});

  const languageCurrentValueRef = useRef(null);

  const parsePathSegments = () => window.location.pathname.split("/").filter(Boolean);

  const buildLanguagePath = (lang) => {
    if (lang === LANGUAGES_CONSTANTS.ENGLISH) return "/en";
    if (lang === LANGUAGES_CONSTANTS.VIETNAMESE) return "/vi";
    if (lang === LANGUAGES_CONSTANTS.KOREAN) return "/ko";
    return "/en";
  };
  const languagePath = buildLanguagePath(selectedLanguage);

  const languageOptions = [
    { name: translations.english, value: LANGUAGES_CONSTANTS.ENGLISH, code: LANGUAGE_CODES.ENGLISH },
    { name: translations.korean, value: LANGUAGES_CONSTANTS.KOREAN, code: LANGUAGE_CODES.KOREAN },
    { name: translations.vietnamese, value: LANGUAGES_CONSTANTS.VIETNAMESE, code: LANGUAGE_CODES.VIETNAMESE },
  ];

  const getLanguageTitle = (value) => {
    return languageOptions.find((item) => item.value === value)?.name || "";
  };

  const getLanguageCode = (value) => {
    return languageOptions.find((item) => item.value === value)?.code || LANGUAGE_CODES.ENGLISH;
  };

  const handleSaveLanguage = async () => {
    if (languageCurrentValueRef.current === selectedLanguage) {
      languageDropdownRef.current?.hide();
      return;
    }
    const isChangeLanguage = await handleLanguageChange(selectedLanguage);
    if (!isChangeLanguage) {
      window.location.reload();
    }
  };

  const handleLanguageChange = async (newLang) => {
    if (newLang === languageCurrentValueRef.current) return false;

    const segments = parsePathSegments();
    if (LANGUAGES.includes(segments[0])) {
      segments.shift();
    }

    await changeLanguageByUser(newLang);
    return true;
  };

  const handleShowLanguageDropdown = () => {
    setSelectedLanguage(languageCurrentValueRef.current);
  };

  const languageOptionTemplate = (option) => {
    return (
      <div className="custom-language-dropdown">
        <span className={`fi fi-${option.code.toLowerCase()} keduall-icon icon-flag`}></span>
        <span>{option.name}</span>
      </div>
    );
  };

  useEffect(() => {
    if (!i18n.isInitialized) {
      initializeI18n().then(() => {
        languageCurrentValueRef.current = i18n.language;
        setSelectedLanguage(i18n.language);
      });
    } else {
      languageCurrentValueRef.current = i18n.language;
      setSelectedLanguage(i18n.language);
    }
  }, []);

  useEffect(() => {
    if (!selectedLanguage) return;
    const loadTranslations = async () => {
      const t = {};
      t.vietnamese = await translate("LANGUAGES.VI");

      t.english = await translate("LANGUAGES.EN");

      t.korean = await translate("LANGUAGES.KO");

      t.saveButtonLabel = await translate("UMBRACO_LANDING.HEADER.SAVE", false, "저장");

      setTranslations(t);
    };
    loadTranslations();
  }, [selectedLanguage]);

  return (
    <div>
      <div className="custom-register-menubar-placeholder"></div>
      <div className="keduall-header custom-menubar">
        <div className="top-header register-header justify-content-between py-125 px-35">
          <div className="flex flex-row align-items-center justify-content-start">
            <a href={languagePath} className="no-underline">
              <img src={registerLogo} alt={APP_NAME} className="register-header-logo m-0 cursor-pointer" style={{ height: "40px", width: "auto", display: "block" }} />
            </a>
          </div>
          <div className="flex justify-content-end align-items-center gap-075">          
            <OverlayPanel ref={languageDropdownRef} className="register-lang-overlay" onShow={handleShowLanguageDropdown} onHide={() => setLanguageDropdownVisible(false)}>
              <div className="header-overlay-wrapper">
                <div>
                  <p className="dropdown-title">{translations?.languageTitle}</p>
                  <Dropdown
                    value={selectedLanguage}
                    onChange={(e) => setSelectedLanguage(e.value)}
                    options={languageOptions}
                    optionLabel="name"
                    itemTemplate={languageOptionTemplate}
                    className="w-full"
                    panelClassName="register-lang-dropdown-panel"
                  />
                </div>
                
                <Button onClick={() => handleSaveLanguage()}>{translations?.saveButtonLabel}</Button>
              </div>
            </OverlayPanel>
            <div
              className="dropdown-link keduall-typography text-16-semibold-600 text-white-txt"
              onClick={(e) => {
                languageDropdownRef.current?.toggle(e);
                setLanguageDropdownVisible(!languageDropdownVisible);
              }}
            >
              <span className={`fi fi-${getLanguageCode(languageCurrentValueRef?.current)?.toLowerCase()} keduall-icon icon-flag`}></span>
              <span className="language-currency-dropdown-title">
                {getLanguageTitle(languageCurrentValueRef.current)}
              </span>
              {languageDropdownVisible ? <i className="pi pi-angle-up"></i> : <i className="pi pi-angle-down"></i>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
